const listingFieldsMap = {
  // Workout Types
  adaptive: 'fa-solid fa-wheelchair',
  aerial: 'fa-solid fa-cloud',
  balance: 'fa-solid fa-scale-balanced',
  barre: 'fa-solid fa-heart-pulse',
  bootcamp: 'fa-solid fa-person-military-pointing',
  boxing: 'fa-solid fa-hand-fist',
  calisthenics: 'fa-solid fa-heart-circle-bolt',
  cardio: 'fa-solid fa-heart-circle-bolt',
  circuit: 'fa-solid fa-person-walking-arrow-loop-left',
  correctives: 'fa-solid fa-user-injured',
  crossfit: 'fa-solid fa-shuffle',
  cycling: 'fa-solid fa-bicycle',
  dance: 'fa-solid fa-music',
  hiit: 'fa-solid fa-fire',
  'jiu-jitsu': 'fa-solid fa-hand-fist',
  meditation: 'fa-solid fa-spa',
  'muay-thai': 'fa-solid fa-hand-fist',
  pilates: 'fa-solid fa-spa',
  pole: 'fa-solid fa-music',
  powerlifting: 'fa-solid fa-weight-hanging',
  recovery: 'fa-solid fa-heart-circle-bolt',
  running: 'fa-solid fa-person-running',
  strength: 'fa-solid fa-dumbbell',
  swimming: 'fa-solid fa-person-swimming',
  'water-aerobics': 'fa-solid fa-water-ladder',
  weights: 'fa-solid fa-dumbbell',
  yoga: 'fa-solid fa-spa',

  // Recognition
  'best-of-city': 'fa-solid fa-building',
  'top-rated': 'fa-solid fa-star',
  'black-owned': '',
  'women-owned': 'fa-solid fa-venus',
  'minority-owned': '',
  'veteran-owned': 'fa-solid fa-ribbon',
  'family-owned': 'fa-solid fa-people-roof',
  'locally-owned': 'fa-solid fa-location-dot',

  // Certificate
  none: '',
  ACE: 'fa-solid fa-certificate',
  ACSM: 'fa-solid fa-certificate',
  AFPA: 'fa-solid fa-certificate',
  Cooper: 'fa-solid fa-certificate',
  ERYT: 'fa-solid fa-certificate',
  EXOS: 'fa-solid fa-certificate',
  ISSA: 'fa-solid fa-certificate',
  NASM: 'fa-solid fa-certificate',
  NCSF: 'fa-solid fa-certificate',
  NFPT: 'fa-solid fa-certificate',
  NSCA: 'fa-solid fa-certificate',
  RYT: 'fa-solid fa-certificate',
  USAW: 'fa-solid fa-certificate',

  // Class Type
  virtual: 'fa-solid fa-computer',
  group: 'fa-solid fa-people-group',
  personal: 'fa-solid fa-person-chalkboard',
  maternity: 'fa-solid fa-person-pregnant',
  'post-partum': 'fa-solid fa-person-breastfeeding',
  athlete: 'fa-solid fa-medal',
};

export default listingFieldsMap;
